export default {
  AD_CLICKED: 'click_ad',
  AD_FINISHED: 'finish_ad',
  AD_STARTED: 'start_ad',
  APP_LANGUAGE_CHANGE: 'change_app_language',
  START_PLAYING: 'start_playing',
  PAUSE_PLAYING: 'pause_playing',
  STOP_PLAYING: 'stop_playing',
  POPUP_CLICK: 'popup_click',
  POPUP_CLOSE: 'popup_close',
  POPUP_SHOW: 'popup_show',
  BUFFERING_WHILE_PLAYING: 'buffering_while_playing',
  ERROR_WHILE_PLAYING: 'error_while_playing',
  CHANGE_PLAYING_SETTINGS: 'change_playing_settings',
  ADD_TO_FAVORITES: 'add_to_favorites',
  LOGIN: 'login',
  LOGOUT: 'logout',
  CHANGE_PROFILE: 'change_profile',
  SHOW_SIGN_UP_FORM: 'show_sign_up_form',
  SHOW_APP_VIEW: 'show_app_view',
};
